import React from 'react';
import { CreativityType } from '../types/banner';
import { ClientHandler } from '../types/client-handler';
import { TemplateConfig } from '../constants/clients/template-config.interface';
import { PreviewsMap } from '../types/demo-previews';

export const useDynamicPreviews = (
  creativityType: CreativityType,
  formData: any,
  clientHandler: ClientHandler,
  template: TemplateConfig | undefined
) => {
  // Detectar si el template usa sistema dinámico
  const hasDynamicPreviews = !!template?.channelConfigs;

  // Obtener previews dinámicas
  const previews = React.useMemo((): PreviewsMap | null => {
    if (!hasDynamicPreviews || !clientHandler.getDemoPreviews) return null;
    return clientHandler.getDemoPreviews(formData, creativityType);
  }, [hasDynamicPreviews, clientHandler, formData, creativityType]);

  // Determinar canales disponibles
  const availableChannels = React.useMemo((): string[] => {
    if (!hasDynamicPreviews || !template?.channelConfigs) return [];

    // Si hay adChannel seleccionado, solo mostrar ese
    if (formData.adChannel) {
      return [formData.adChannel];
    }

    // Si no hay adChannel, detectar qué canales tienen previews
    if (!previews) return [];

    const channelsWithPreviews = new Set<string>();

    Object.values(previews).forEach(preview => {
      const first = Array.isArray(preview) ? preview[0] : preview;
      const channel = first?.metadata?.channel;
      if (channel) {
        channelsWithPreviews.add(channel);
      }
    });

    return Array.from(channelsWithPreviews);
  }, [hasDynamicPreviews, template, formData.adChannel, previews]);

  return {
    hasDynamicPreviews,
    previews,
    availableChannels
  };
};
